import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { getTagsFromText } from '../../../../helpers';

export const FallbackComponent = () => {
  const { t } = useTranslation();
  const errorMessage = getTagsFromText(
    [
      [t('fallback.1')],
      ['strong', t('fallback.2')],
      [t('fallback.3')],
    ],
  );
  return (
    <>
      <LinkOffIcon sx={{ fontSize: 120, color: '#006FF5' }} />
      <Typography
        style={{ fontSize: '15px' }}
        align="center"
        data-testid="fallbacktext"
      >
        {errorMessage}
      </Typography>
    </>
  );
};
